<template>
  <div style="min-width: 1800px">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">ETP业务系统</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>持仓数据统计</el-breadcrumb-item>
    </el-breadcrumb>

    <el-row :gutter="20" style="margin-top: 20px">
      <el-col :span="10">
        <div id="position-money-oness" style="width: 100%; height: 350px"></div>
      </el-col>
      <el-col :span="10">
        <div id="position-people-ones" style="width: 100%; height: 350px">
        </div>
      </el-col>
    </el-row>

    <div>
      <h1 style="font-size: 18px; display: inline-block">持仓数据</h1>
      <span style="font-size: 14px; padding-left: 20px; padding-right: 10px"
        >日期</span
      >
      <el-date-picker
        v-model="queryParam.queryTime"
        type="date"
        value-format="timestamp"
        placeholder="选择日期"
      ></el-date-picker>
      <el-button type="primary" @click="searchData">查 询</el-button>

      <el-table
        border
        :header-cell-style="{ background: '#FFF5F4', color: '#EC6D56' }"
        style="margin-top: 10px"
        :data="dataList"
        :row-key="() => Math.random()"
      >
        <el-table-column label="序号">
          <el-table-column
            label="合计"
            type="index"
            :index="indexMethod"
            width="100px"
          ></el-table-column>
        </el-table-column>
        <el-table-column label="交易币种">
          <el-table-column label="全部" prop="coin"></el-table-column>
        </el-table-column>
        <el-table-column label="持仓量（USDT）">
          <el-table-column
            :label="sumUserHoldProportion.sumHoldAmount + ''"
            prop="sumHoldAmount"
          ></el-table-column>
        </el-table-column>
        <el-table-column label="持仓人数">
          <el-table-column
            :label="sumUserHoldProportion.sumHoldNumber + ''"
            prop="sumHoldNumber"
          ></el-table-column>
        </el-table-column>
        <el-table-column label="3L/3S资金量多空比">
          <el-table-column
            :label="
              (sumUserHoldProportion.amountRate3L * 100).toFixed(2) +
              '%/' +
              (sumUserHoldProportion.amountRate3S * 100).toFixed(2) +
              '%'
            "
          >
            <template slot-scope="scope">
              {{
                (scope.row.amountRate3L * 100).toFixed(2) +
                "%/" +
                (scope.row.amountRate3S * 100).toFixed(2) +
                "%"
              }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="5L/5S资金量多空比">
          <el-table-column
            :label="
              (sumUserHoldProportion.amountRate5L * 100).toFixed(2) +
              '%/' +
              (sumUserHoldProportion.amountRate5S * 100).toFixed(2) +
              '%'
            "
          >
            <template slot-scope="scope">
              {{
                (scope.row.amountRate5L * 100).toFixed(2) +
                "%/" +
                (scope.row.amountRate5S * 100).toFixed(2) +
                "%"
              }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="3L/3S持仓人数多空比">
          <el-table-column
            :label="
              (sumUserHoldProportion.numberRate3L * 100).toFixed(2) +
              '%/' +
              (sumUserHoldProportion.numberRate3S * 100).toFixed(2) +
              '%'
            "
          >
            <template slot-scope="scope">
              {{
                (scope.row.numberRate3L * 100).toFixed(2) +
                "%/" +
                (scope.row.numberRate3S * 100).toFixed(2) +
                "%"
              }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="5L/5S持仓人数多空比">
          <el-table-column
            :label="
              (sumUserHoldProportion.numberRate5L * 100).toFixed(2) +
              '%/' +
              (sumUserHoldProportion.numberRate5S * 100).toFixed(2) +
              '%'
            "
          >
            <template slot-scope="scope">
              {{
                (scope.row.numberRate5L * 100).toFixed(2) +
                "%/" +
                (scope.row.numberRate5S * 100).toFixed(2) +
                "%"
              }}
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>

      <el-pagination
        style="margin-top: 30px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParam.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryParam.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import "./store";
import api from "./api";

export default {
  name: "PositionData",
  data() {
    return {
      dataList: [],
      total: 0,
      positionMoneyOneOption: null,
      positionMoneyOneChart: null,
      positionMoneyTwoOption: null,
      positionMoneyTwoChart: null,
      positionPeopleOneOption: null,
      positionPeopleOneChart: null,
      positionPeopleTwoOption: null,
      positionPeopleTwoChart: null,
      queryParam: { queryTime: "", page: 1, size: 10 },
      sumUserHoldProportion: {},
    };
  },
  methods: {
    indexMethod(index) {
      return index + 1;
    },
    searchData() {
      this.getPositionList();
    },
    getPositionList() {
      api.getPositionList(this.queryParam).then(({ data }) => {
        this.dataList = data.userHoldProportionListVOList.records;
        this.total = data.userHoldProportionListVOList.total;
        this.sumUserHoldProportion = data.sumUserHoldProportionListVO;

        this.initPositionMoneyOne(data);
        this.initPositionPeopleOne(data);
      });
    },
    arrCount(arr) {
      let count = 0;
      arr.forEach((item) => {
        count = count + item.num;
      });
      return count;
    },
    initPositionMoneyOne(data) {
      let positionMoneyOne = document.getElementById("position-money-oness");
      this.positionMoneyOneChart = this.$echarts.init(positionMoneyOne);
      this.positionMoneyOneOption = {
        title: {
          text: "持仓资金量统计",
        },
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            return params.name + " " + params.percent + "%";
          },
        },
        legend: {
          orient: "vertical",
          align: "left",
          right: 100,
          formatter: (name) => {
            const count = this.arrCount(data.userHoldCapitalVOList);
            const val = data.userHoldCapitalVOList.filter((item) => {
              return item.coinType === name;
            });
            return (
              name + "     " + ((val[0].num / count) * 100).toFixed(4) + "%" + '  '+ (val[0].num).toFixed(2)+'USDT'
            );
          },
        },
        series: [
          {
            type: "pie",
            radius: "60%",
            data: [],
            right:300,
            emphasis: {
              itemStyle: {
                shadowBlur: 2,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      if (data.userHoldCapitalVOList) {
        for (let i = 0; i < data.userHoldCapitalVOList.length; i++) {
          this.positionMoneyOneOption.series[0].data.push({
            name: data.userHoldCapitalVOList[i].coinType,
            value: data.userHoldCapitalVOList[i].num,
          });
        }
      }
      this.positionMoneyOneOption &&
        this.positionMoneyOneChart.setOption(this.positionMoneyOneOption);
    },
    initPositionPeopleOne(data) {
      let positionPeopleOne = document.getElementById("position-people-ones");
      this.positionPeopleOneChart = this.$echarts.init(positionPeopleOne);
      this.positionPeopleOneOption = {
        title: {
          text: "持仓人数统计",
        },
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            return params.name + " " + params.percent + "%";
          },
        },
        legend: {
          orient: "vertical",
          align: "left",
          right: 100,
          formatter: (name) => {
            const count = this.arrCount(data.userHoldPeopleVOList);
            const val = data.userHoldPeopleVOList.filter((item) => {
              return item.coinType === name;
            });
            return (
              name + "     " + ((val[0].num / count) * 100).toFixed(4) + "%" + '  '+ (val[0].num).toFixed(2)+'人'
            );
          },
        },
        series: [
          {
            type: "pie",
            radius: "60%",
            data: [],
            right:300,
            emphasis: {
              itemStyle: {
                shadowBlur: 2,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      if (data.userHoldPeopleVOList) {
        for (let i = 0; i < data.userHoldPeopleVOList.length; i++) {
          this.positionPeopleOneOption.series[0].data.push({
            name: data.userHoldPeopleVOList[i].coinType,
            value: data.userHoldPeopleVOList[i].num,
          });
        }
      }
      this.positionPeopleOneOption &&
        this.positionPeopleOneChart.setOption(this.positionPeopleOneOption);
    },
    handleSizeChange(val) {
      this.queryParam.size = val;
      this.getPositionList();
    },
    handleCurrentChange(val) {
      this.queryParam.page = val;
      this.getPositionList();
    },
  },
  created() {},
  mounted() {
    this.getPositionList();
  },
};
</script>

<style lang="less" scoped></style>

